import script from "./PcPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PcPage.vue?vue&type=script&setup=true&lang=js"

import "./PcPage.vue?vue&type=style&index=0&id=1601b769&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.3.1_vue@3.3.7_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1601b769"]])

export default __exports__